import { Component, Input } from '@angular/core';
import { Platform, PopoverController } from 'ionic-angular';
import { NetworkStatus } from '../../../core/business-objects/network/network-status';
import { BaseComponent } from '../../../core/components/base.component';
import { Account } from '../../business-objects/account/account.model';
import { VasAppFacade } from '../../services/vas-app-facade.service';

@Component({
    selector: 'vas-nav-bar',
    template: `
        <ion-navbar>
            <button
                ion-button
                menuToggle>
                <ion-icon name="menu"></ion-icon>
            </button>
            <ion-title>{{title}}</ion-title>
            <ion-buttons end>
                <online-status></online-status>
                <user-popover-button></user-popover-button>
            </ion-buttons>
        </ion-navbar>
        <div class="toolbar-background toolbar-background-ios"></div>
    `
})
export class NavBarComponent extends BaseComponent {
    @Input() title: string;

    activeAccount: Account;
    protected networkStatus: NetworkStatus;

    constructor(
        protected appFacade: VasAppFacade,
        protected popoverCtrl: PopoverController,
        protected platform: Platform
    ) {
        super();
    }

    ngOnInit(): void {

        this.appFacade.objects.account.store.getActive()
            .takeUntil(this.ngUnsubscribe)
            .subscribe(account => this.activeAccount = account);

        this.appFacade.network.getNetworkStatus()
            .takeUntil(this.ngUnsubscribe)
            .subscribe(networkStatus => this.networkStatus = networkStatus);
    }

    get activeAccountId(): string {
        return this.activeAccount ? this.activeAccount.id : '';
    }

    get showTasksButton(): boolean {
        return !!this.activeAccount;
    }

    get showCalendarButton(): boolean {
        return !!this.activeAccount;
    }

    onShowMoreButtonsPicker($event): void {
        const p = this.popoverCtrl.create('MoreButtonsPicker', {
            accountId: this.activeAccountId,
            showCalendarButton: this.showCalendarButton,
            showTasksButton: this.showTasksButton
        });

        p.present({
            ev: $event
        });
    }

    get isDesktop(): boolean {
        return this.platform.is('core');
    }

}



// WEBPACK FOOTER //
// ./src/vas/modules-shared/nav-bar/nav-bar.component.ts